import React from "react";
import { Link } from "react-router-dom";

function NavBtn(props) {
  const { children, styl, name, loc, onClick } = props;
  return (
    <Link to={loc} className={styl} onClick={onClick}>
      <span className="d-block me-2 mb-1">{children}</span>
      <span className="d-block">{name}</span>
    </Link>
  );
}

export default NavBtn;
